import { Skeleton } from '@/components/ui/skeleton';

/* ------------------------------------------------------------------ */
/*  ConnectorRowSkeleton                                               */
/*                                                                     */
/*  Mirrors the shape of ConnectorRow so loading lists settle into     */
/*  content without a layout shift. Shared by the dashboard and the    */
/*  connectors table. Kept in its own import-light module (only the    */
/*  Skeleton primitive) so it can be pulled into route-level loading    */
/*  fallbacks without dragging in ConnectorRow's charts/hooks.         */
/* ------------------------------------------------------------------ */

export function ConnectorRowSkeleton() {
  return (
    <div className="bg-card flex flex-col gap-3 rounded-xl border p-4">
      {/* Header: avatar + name/status */}
      <div className="flex items-center gap-3">
        <Skeleton className="rounded-squircle h-10 w-10 shrink-0 sm:h-8 sm:w-8" />
        <div className="flex min-w-0 flex-col gap-1.5">
          <Skeleton className="h-3.5 w-28" />
          <Skeleton className="h-3 w-16" />
        </div>
      </div>
      {/* Breakdown stats — mirrors the EntityStat row (icon + two text lines) */}
      <div className="flex gap-4 border-t pt-3">
        {Array.from({ length: 2 }).map((_, i) => (
          <div key={i} className="flex items-center gap-2">
            <Skeleton className="h-6 w-6 shrink-0 rounded-md" />
            <div className="flex flex-col gap-1">
              <Skeleton className="h-3 w-8" />
              <Skeleton className="h-2.5 w-14" />
            </div>
          </div>
        ))}
      </div>
      {/* Mini chart */}
      <Skeleton className="mt-3 h-12 w-full border-t" />
      {/* Run history strip */}
      <div className="flex gap-1 border-t pt-3">
        {Array.from({ length: 8 }).map((_, i) => (
          <Skeleton key={i} className="h-5 flex-1" />
        ))}
      </div>
    </div>
  );
}
